import { snakeCase } from 'lodash';
import { SnakeCase } from 'type-fest';

import { Product } from '@notino/web-tracking/dist/types/package/ga4/events/products';

import { TrackingAttributes } from '@context/tracking/types';
import { dispatchTrackingEvent } from '@context/tracking/utils';

import {
  ShadefinderShadesKeys,
  ShadefinderShadeUndertoneKeys,
  ShadefinderDesiredShadeKeys,
} from './types';

export const trackShadefinderOpen = (
  props: TrackingAttributes<{ product: Product }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_open',
    shadefinder: {
      action: 'shadefinder_open',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
    },
    _clear: true,
  });
};

export const trackShadefinderSelectShade = (
  props: TrackingAttributes<{ product: Product; name: ShadefinderShadesKeys }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_select_shade',
    shadefinder: {
      action: 'shadefinder_shade_selected',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
      name: snakeCase(props.name) as SnakeCase<ShadefinderShadesKeys>,
    },
    _clear: true,
  });
};

export const trackShadefinderSelectUndertone = (
  props: TrackingAttributes<{
    product: Product;
    name: ShadefinderShadeUndertoneKeys;
  }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_select_undertone',
    shadefinder: {
      action: 'shadefinder_undertone_selected',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
      name: snakeCase(props.name) as SnakeCase<ShadefinderShadeUndertoneKeys>,
    },
    _clear: true,
  });
};

export const trackShadefinderSelectTone = (
  props: TrackingAttributes<{
    product: Product;
    name: ShadefinderDesiredShadeKeys;
  }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_select_tone',
    shadefinder: {
      action: 'shadefinder_tone_selected',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
      name: snakeCase(props.name) as SnakeCase<ShadefinderDesiredShadeKeys>,
    },
    _clear: true,
  });
};

export const trackShadefinderDisplayResult = (
  props: TrackingAttributes<{ product: Product }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_display_result',
    shadefinder: {
      action: 'shadefinder_recommendation_displayed',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
    },
    _clear: true,
  });
};

export const trackShadefinderSelectResult = (
  props: TrackingAttributes<{ product: Product }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_select_product',
    shadefinder: {
      action: 'shadefinder_recommendation_selected',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      products: [props.product],
    },
    _clear: true,
  });
};

export const trackShadefinderHowWeSelectClick = (props: TrackingAttributes) => {
  dispatchTrackingEvent({
    event: 'shadefinder_how_we_select',
    shadefinder: {
      action: 'shadefinder_page_how_we_select',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
    },
    _clear: true,
  });
};

export const trackShadefinderBack = (
  props: TrackingAttributes<{ name?: string }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_back',
    shadefinder: {
      action: 'shadefinder_back',
      variant: props.variant,
      timing: props.timing,
      interaction: 'click',
      name: props.name as string,
      products: [] as Product[],
    },
    _clear: true,
  });
};

export const trackShadefinderClose = (
  props: TrackingAttributes<{ interaction?: string; name: string }>
) => {
  dispatchTrackingEvent({
    event: 'shadefinder_close',
    shadefinder: {
      action: 'shadefinder_closed',
      variant: props.variant,
      timing: props.timing,
      interaction: props.interaction || 'click',
      name: props.name,
    },
    _clear: true,
  });
};
